import { supabase } from '../../../../services/supabase';

export type UpdateTeamInput = {
  teamId: string;
  name?: string;
  workHoursStart?: string;
  workHoursEnd?: string;
  checkInTimes?: string[];
  teamMembers?: string[];
  teamLeadId?: string;
  accountManagerId?: string;
};

export async function updateTeamDetails(input: UpdateTeamInput): Promise<void> {
  if (!input.teamId) {
    throw new Error('Team ID is required');
  }

  // Prepare update object with only the provided fields
  const updateData: Record<string, any> = {
    ...(input.name && { name: input.name }),
    ...(input.workHoursStart && { work_hours_start: input.workHoursStart }),
    ...(input.workHoursEnd && { work_hours_end: input.workHoursEnd }),
    ...(input.checkInTimes && { check_in_times: input.checkInTimes }),
    ...(input.teamMembers && { team_members: input.teamMembers }),
    ...(input.teamLeadId && { manager_id: input.teamLeadId }),
    ...(input.accountManagerId && {
      account_manager_id: input.accountManagerId,
    }),
  };

  const { error } = await supabase
    .from('teams')
    .update(updateData)
    .eq('id', input.teamId);

  if (error) {
    throw new Error(`Failed to update team details: ${error.message}`);
  }
}
